import { render, staticRenderFns } from "./NonAgentNovelListItem.vue?vue&type=template&id=21f94a92&scoped=true"
import script from "./NonAgentNovelListItem.vue?vue&type=script&lang=ts"
export * from "./NonAgentNovelListItem.vue?vue&type=script&lang=ts"
import style0 from "./NonAgentNovelListItem.vue?vue&type=style&index=0&id=21f94a92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f94a92",
  null
  
)

export default component.exports